import React from "react";
import { Store } from "lucide-react";
import { useStore } from "@/lib/storeContext";

export default function StoreSwitcher({ compact = false }) {
  const { stores, storeId, setStoreId, multi } = useStore();
  if (!multi || !Array.isArray(stores) || stores.length < 2) return null;
  return (
    <label className={`inline-flex items-center gap-2 ${compact ? "" : "min-w-[12rem]"}`} data-testid="store-switcher">
      <Store className="w-4 h-4 text-velta-mute shrink-0" />
      <select
        data-testid="store-switcher-select"
        value={storeId}
        onChange={(e) => setStoreId(e.target.value)}
        className="h-9 max-w-[14rem] bg-white border border-velta-border rounded-md px-2 text-sm outline-none focus:border-velta-ink"
        title="Sede: filtra cassa, magazzino, stampanti e report"
      >
        <option value="">Tutte le sedi</option>
        {(Array.isArray(stores) ? stores : []).map((s) => (
          <option key={s.id} value={s.id}>{s.name}{s.is_main ? " · principale" : ""}</option>
        ))}
      </select>
    </label>
  );
}
